var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader d-flex flex-column",staticStyle:{"background":"white","position":"fixed","justify-content":"center","align-items":"center","top":"0","left":"0","right":"0","bottom":"0","z-index":"10000"}},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',[_c('strong',[_vm._v("Cargando ... ")])])])
}]

export { render, staticRenderFns }